import React, { useState } from "react";

const InputCheckBox = ({ title, item, fontLight }) => {
  const [value, setValue] = useState("");
  const [toggleCheck, setToggleCheck] = useState(false);
  const handleInput = (e) => {
    setValue(e.target.value);
  };
  const handleCheck = () => {
    setValue(true);
    setToggleCheck(!toggleCheck);
  };

  return (
    <div
      style={fontLight ? { color: "#c1c1c1" } : {}}
      className={item ? "input__checkbox-reverse" : "input__checkbox "}
    >
      <label className="input__label" htmlFor="acc">
        {title ? title : "Accumulated"}
      </label>

      <input
        type="checkbox"
        className="input__check "
        placeholder=""
        value={value}
        onChange={handleInput}
        id="acc"
      />

      <div
        className="check-fake-container"
        onClick={handleCheck}
        style={{ backgroundColor: toggleCheck ? "#ff8900" : "" }}
      >
        {toggleCheck && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="check-icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 13.5l6.75 6.75L21 4.5"
            />
          </svg>
        )}
      </div>
    </div>
  );
};
export default InputCheckBox;
